var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJoberIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.0081667,0 C12.1856667,0 13.1773333,0.819166667 13.4348333,1.9425 C15.8281667,2.6975 17.4131667,4.9975 17.4965,8.07583333 L17.4965,8.07583333 L19.0265,10.3708333 L18.3331667,11.6666667 L17.5765,11.6666667 L17.5765,12.5 C17.5765,16.635 14.2115,20 10.0765,20 C5.9415,20 2.5765,16.635 2.5765,12.5 L2.5765,12.5 L2.5765,11.6666667 L1.6665,11.6666667 L0.973166667,10.3708333 L2.504,8.07583333 C2.58733333,4.99666667 4.17233333,2.69583333 6.56733333,1.94166667 C6.8315,0.811666667 7.81983333,0 8.9915,0 L8.9915,0 Z M15.9098333,11.6666667 L4.24316667,11.6666667 L4.24316667,12.5 C4.24316667,15.7166667 6.85983333,18.3333333 10.0765,18.3333333 C13.2931667,18.3333333 15.9098333,15.7166667 15.9098333,12.5 L15.9098333,12.5 L15.9098333,11.6666667 Z M7.08333333,12.5 C7.77333333,12.5 8.33333333,13.06 8.33333333,13.75 C8.33333333,14.44 7.77333333,15 7.08333333,15 C6.39333333,15 5.83333333,14.44 5.83333333,13.75 C5.83333333,13.06 6.39333333,12.5 7.08333333,12.5 Z M12.9166667,12.5 C13.6066667,12.5 14.1666667,13.06 14.1666667,13.75 C14.1666667,14.44 13.6066667,15 12.9166667,15 C12.2266667,15 11.6666667,14.44 11.6666667,13.75 C11.6666667,13.06 12.2266667,12.5 12.9166667,12.5 Z M11.0081667,1.66666667 L8.9915,1.66666667 C8.5665,1.66666667 8.21066667,1.98583333 8.16316667,2.40833333 L8.16316667,2.40833333 L7.67066667,8.07583333 L5.99733333,8.07583333 L6.36816667,3.81333333 C4.78233333,4.68583333 4.1665,6.6125 4.1665,8.33333333 L4.1665,8.33333333 L4.1665,8.58583333 L3.224,10 L16.7765,10 L15.8331667,8.58583333 L15.8331667,8.33333333 C15.8331667,6.6125 15.2173333,4.68583333 13.6315,3.81333333 L13.6315,3.81333333 L14.0023333,8.07583333 L12.3298333,8.07583333 L11.8348333,2.38833333 C11.7898333,1.98583333 11.4331667,1.66666667 11.0081667,1.66666667 L11.0081667,1.66666667 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icono-/-Background-/-Pro-/-Full",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    fill: "#D2D2D2",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    rx: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icono-/-Pro-/-Outline",
    transform: "translate(10.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Black-/-800",
    mask: "url(#mask-2)",
    fill: "#444444",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoberIcon);
export default __webpack_public_path__ + "static/media/jober-icon.7aa3937fbe924c05503f408077444901.svg";
export { ForwardRef as ReactComponent };